//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const fallback = {
  nombre: null,
  apellido_paterno: null,
  apellido_materno: null,
  tipo_credito: null,
  desarrollo_id: null,
  celular: null,
  curp: null,
}

export default {
  props: {
    prospecto: {
      required: true,
      type: Object,
      default() {
        return fallback
      }
    },
    disable: {
      type: Boolean,
      default() {
        return false
      }
    },
    readonly: {
      type: Boolean,
      default() {
        return false
      }
    }
  },

  data() {
    return {
      tipos_credito: [
        { value: 'bancario', label: 'Bancario' },
        { value: 'fovissste', label: 'FOVISSSTE' },
        { value: 'infonavit', label: 'INFONAVIT' },
        { value: 'otro', label: 'Otro' },
      ]
    }
  }
}
